// extracted by mini-css-extract-plugin
export default {"button":"ShowMoreButton_button__Fl2oF","text":"ShowMoreButton_text__UZL1t","arrow":"ShowMoreButton_arrow__qQ+Oh","arrowUp":"ShowMoreButton_arrowUp__ZCySB"};